export default "__VITE_ASSET__DYqqe7pk__"